module.exports = __webpack_public_path__ + "img/example.ca167054.jpg";